



























































import { Component, Vue, Prop, Provide, Watch, Emit, Mixins } from 'vue-property-decorator'
import { Modal } from '@/components'
// import { sa } from '@/utils/sa'
import { couponNum, downloadPaper, updateQuestionCart, getDownloadInfo } from './../model/api'
import DownloadQuestionsMixin from './DownloadQuestionsMixin'

const downloadAudioTypes = [
  [1, '合成一个音频下载'],
  [2, '分题下载'],
  [0, '不下载音频']
]

@Component({
  components: { Modal }
})
export default class DownLoadMOdal extends Mixins(DownloadQuestionsMixin) {
  @Prop() public value!: boolean
  @Prop() public home!: string
  @Prop() public hasAudio!: boolean
  @Prop() public from!: string
  public visible = false
  public name = ''
  public value1 = '1'
  public value3 = '1'
  public data: any = {}
  public title = '试卷下载'
  public loading = false
  public price = 1
  public remaining = 0
  public AudioType = 1
  public plainOptions1 = [
    { label: 'DOCX-标准版', value: '1' },
    { label: 'PDF-双栏版', value: '2' }
  ]
  public plainOptions3 = [
    { label: '普通试卷（答案在卷尾）', value: '1' },
    { label: '教师试卷（答案在题目后）', value: '2' }
  ]
  public get cartInfo() {
    return this.$store.state.question.cart
  }
  public get subjectId() {
    return this.$store.state.subject.value
  }
  public get position() {
    return this.$route.meta.title
  }
  public get downloadAudioTypes() {
    return this.$store.state.downloadAudioTypes || downloadAudioTypes
  }
  public paperContent: any[] = ['1', '2', '3', '4'] //, '4'
  public paperContentOptions = [
    { label: '答案', value: '1' },
    { label: '解析', value: '2' },
    { label: '知识点', value: '3' },
    { label: '来源', value: '4' }
  ]
  @Watch('value')
  public onValueChange(val: boolean) {
    this.visible = val
  }
  @Emit()
  onCancel(val: any) {
    return val
  }
  public closeModal() {
    this.visible = false
    this.onCancel(this.visible)
  }
  public async clearCart() {
    let params: any = {
      question_cart: {
        question_ids: []
      },
      subject_id: this.subjectId
    }
    if (this.home === 'auto') {
      params.usage = 2
    }
    let { data } = await updateQuestionCart(params)
  }
  public async download() {
    this.loading = true
    let count = 0
    let self = this
    let params: any = {
      subject_id: this.subjectId,
      split_stem_answer: this.value3 === '1',
      format: 'docx',
      compact_typesetting: this.value1 === '2',
      with_answer: this.paperContent.includes('1'),
      with_analysis: this.paperContent.includes('2'),
      with_knowledge_points: this.paperContent.includes('3'),
      with_source: this.paperContent.includes('4'),
      with_audio_type: this.AudioType
    }
    if (this.home === 'auto') {
      params.usage = 2
    }
    window['sensors'].track('TIKU_Download', {
      proSource: this.from,
      content: '试卷',
      paper_subject: this.$store.state.subject.label,
      is_not: '是'
    })
    try {
      let data: any = await downloadPaper(params)
      // this.loading = false
      if (data.success) {
        this.getSource(data.data.task_id, count, this.home)
      } else {
        this.visible = false
        this.onCancel(this.visible)
        this.loading = false
        this.$message.warning(data.error)
      }
    } catch (e) {
      this.visible = false
      this.onCancel(this.visible)
      this.loading = false
    }
  }
  public onChange1() {}
  public onChange3() {}
}
